export default __webpack_public_path__ + "static/chumbador-d043b3fc45616edc3547cb1efe37519d.png";